export default __webpack_public_path__ + "static/media/IMG_0334 copie.e09592d1.jpg";